import { render, staticRenderFns } from "./MailServiceEmpty.vue?vue&type=template&id=753485eb"
import script from "./MailServiceEmpty.vue?vue&type=script&lang=js"
export * from "./MailServiceEmpty.vue?vue&type=script&lang=js"
import style0 from "./MailServiceEmpty.vue?vue&type=style&index=0&id=753485eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports